import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-style-guide';
import { DeviceMeta } from 'Roblox';
import PremiumService from '../services/premiumService';

const { isInApp } = DeviceMeta();

function GameBenefitSection({ translate }) {
  function GameBackground(indexArray = [1, 2, 3, 4, 5]) {
    const listItems = indexArray.map(index => {
      const cssStyleName = `bef-game bef-game-${index}`;
      return (
        <li>
          <div className={cssStyleName} />
        </li>
      );
    });
    return listItems;
  }

  return (
    <div className='game-benefit-section'>
      <div className='game-benefit-header left-header'>
        <div className='font-title'>{translate('Heading.PremiumBenefit')}</div>
        <div className='font-header-2 text-subheader'>
          {translate('Description.GetAccessToGame')}
        </div>
      </div>
      <div className='game-benefit-thumbnails'>
        <ul>{GameBackground()}</ul>
      </div>
      <div className='characters digital-artist' />
      {!isInApp && (
        <div className='premium-game-link'>
          <Link url={PremiumService.getPremiumGameUrl()} className='text-link' target='_blank'>
            {translate('Description.PremiumGamesLink')}
          </Link>
        </div>
      )}
    </div>
  );
}

GameBenefitSection.propTypes = {
  translate: PropTypes.func.isRequired
};

export default GameBenefitSection;
